import { render, staticRenderFns } from "./DetailPopup.vue?vue&type=template&id=cf96f254&scoped=true&"
import script from "./DetailPopup.vue?vue&type=script&lang=js&"
export * from "./DetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./DetailPopup.vue?vue&type=style&index=0&id=cf96f254&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf96f254",
  null
  
)

export default component.exports